import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";
import BlogPostsViewer from "./files/blogPostsViewer";
import NewPost from "./files/newPost";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<Controller />} />
                        <Route path="/:blogID" element={<BlogPostsViewer />} />
                        <Route path="/:blogID/newPost" element={<NewPost modify={false} />} />
                        <Route path="/:blogID/modifyPost/:postID" element={<NewPost modify={true} />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
